import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const WEALTH_USER_ASSIGNMENTS =
  'WEALTH_USER_ASSIGNMENTS';

const apiCall = createApiCall(
  WEALTH_USER_ASSIGNMENTS,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/wealth/user-assignments`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
